const chapter = {
  id: 'chemistry-everyday-life',
  slug: 'chemistry-everyday-life',
  subject: 'chemistry',
  subjectLabel: 'Chemistry',
  exam: 'JEE Main + NEET',
  title: {
    english: 'Chemistry in Everyday Life',
        hindi: 'दैनिक जीवन में रसायन',
  },
  estReadMinutes: 40,
  difficulty: {
    english: 'Easy',
        hindi: 'आसान',
  },
  weightage: {
    english: '1 question in JEE Main / NEET',
        hindi: 'जेईई मेन/एनईईटी में 1 प्रश्न',
  },
  syllabusTags: ['Applied Chemistry', 'JEE-Main', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'drug-classification',
      title: {
        english: 'Drugs — Classification',
        hindi: 'औषधि — वर्गीकरण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Drug = chemical (low MW 100-500) producing biological response.',
        hindi: 'दवा = जैविक प्रतिक्रिया उत्पन्न करने वाला रसायन (कम मेगावाट 100-500)।',
            },
            {
              english: 'Therapeutic dose ≪ toxic dose; chemotherapy = use of drugs to treat disease.',
        hindi: 'चिकित्सीय खुराक ≪ विषाक्त खुराक; कीमोथेरेपी = बीमारी के इलाज के लिए दवाओं का उपयोग।',
            },
            {
              english: 'Classification:',
        hindi: 'वर्गीकरण:',
            },
            {
              english: '• **By pharmacological effect** (analgesic, antiseptic).',
        hindi: '• **औषधीय प्रभाव से** (एनाल्जेसिक, एंटीसेप्टिक)।',
            },
            {
              english: '• **By drug action** (mechanism — e.g. antihistamine).',
        hindi: '• **दवा की क्रिया द्वारा** (तंत्र - जैसे एंटीहिस्टामाइन)।',
            },
            {
              english: '• **By chemical structure** (sulpha drugs, β-lactam antibiotics).',
        hindi: '• **रासायनिक संरचना द्वारा** (सल्फा दवाएं, β-लैक्टम एंटीबायोटिक्स)।',
            },
            {
              english: '• **By molecular target** (enzyme inhibitor, receptor blocker).',
        hindi: '• **आण्विक लक्ष्य द्वारा** (एंजाइम अवरोधक, रिसेप्टर अवरोधक)।',
            },
            {
              english: 'Drug-target interaction: enzymes (active site / allosteric inhibition); receptors (agonist activates, antagonist blocks).',
        hindi: 'दवा-लक्ष्य अंतःक्रिया: एंजाइम (सक्रिय साइट / एलोस्टेरिक निषेध); रिसेप्टर्स (एगोनिस्ट सक्रिय करता है, प्रतिपक्षी ब्लॉक)।',
            },
          ],
        },
      ],
    },
    {
      id: 'drug-types',
      title: {
        english: 'Important Classes',
        hindi: 'महत्वपूर्ण वर्ग',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Antacids** — neutralise stomach HCl. Mild: NaHCO₃, Mg(OH)₂, Al(OH)₃. Modern: H₂-receptor blockers (cimetidine, ranitidine — Zantac), proton pump inhibitors (omeprazole, lansoprazole).',
        hindi: '**एंटासिड्स** - पेट के एचसीएल को निष्क्रिय करें। हल्का: NaHCO₃, Mg(OH)₂, Al(OH)₃. आधुनिक: एच₂-रिसेप्टर ब्लॉकर्स (सिमेटिडाइन, रैनिटिडिन - ज़ैंटैक), प्रोटॉन पंप अवरोधक (ओमेप्राज़ोल, लैंसोप्राज़ोल)।',
            },
            {
              english: '**Antihistamines** — treat allergies; block H₁-receptors. Brompheniramine (Dimetapp), terfenadine (Seldane).',
        hindi: '**एंटीहिस्टामाइन्स** - एलर्जी का इलाज करें; H₁-रिसेप्टर्स को ब्लॉक करें। ब्रोम्फेनिरामाइन (डिमेटैप), टेरफेनडाइन (सेल्डेन)।',
            },
            {
              english: '**Tranquilisers** — relieve anxiety. Mild: equanil, meprobamate. Hypnotic: barbiturates (luminal, seconal — sleep). Antidepressant: iproniazid, phenelzine. Chlordiazepoxide, diazepam (valium).',
        hindi: '**ट्रैंक्विलाइज़र** - चिंता दूर करें। हल्का: इक्वेनिल, मेप्रोबैमेट। कृत्रिम निद्रावस्था: बार्बिटुरेट्स (ल्यूमिनल, सेकोनल-नींद)। एंटीडिप्रेसेंट: आईप्रोनियाज़िड, फेनलज़ीन। क्लॉर्डियाज़ेपॉक्साइड, डायजेपाम (वैलियम)।',
            },
            {
              english: '**Analgesics** — relieve pain.',
        hindi: '**एनाल्जेसिक** - दर्द से राहत।',
            },
            {
              english: '• **Non-narcotic / non-addictive**: aspirin (also prevents platelet aggregation; given after MI), paracetamol.',
        hindi: '• **गैर-मादक/गैर-नशे की लत**: एस्पिरिन (प्लेटलेट एकत्रीकरण को भी रोकता है; एमआई के बाद दिया जाता है), पेरासिटामोल।',
            },
            {
              english: '• **Narcotic** (opioids — addictive): morphine, codeine, heroin (acetylated morphine).',
        hindi: '• **नारकोटिक** (ओपिओइड - नशे की लत): मॉर्फिन, कोडीन, हेरोइन (एसिटिलेटेड मॉर्फिन)।',
            },
            {
              english: '**Antimicrobials** — kill / inhibit microbes:',
        hindi: '**रोगाणुरोधी** - रोगाणुओं को मारें/रोकें:',
            },
            {
              english: '• **Antibiotics**: produced by microorganisms. Penicillin (β-lactam — Fleming, 1929), ampicillin, amoxycillin (semi-synthetic), tetracycline, chloramphenicol (broad spectrum).',
        hindi: '• **एंटीबायोटिक्स**: सूक्ष्मजीवों द्वारा उत्पादित। पेनिसिलिन (बीटा-लैक्टम - फ्लेमिंग, 1929), एम्पीसिलीन, एमोक्सिसिलिन (अर्ध-सिंथेटिक), टेट्रासाइक्लिन, क्लोरैम्फेनिकॉल (व्यापक स्पेक्ट्रम)।',
            },
            {
              english: '  – **Bactericidal** (kill): penicillin, ofloxacin, aminoglycosides.',
        hindi: '- **जीवाणुनाशक** (मार): पेनिसिलिन, ओफ़्लॉक्सासिन, एमिनोग्लाइकोसाइड्स।',
            },
            {
              english: '  – **Bacteriostatic** (inhibit growth): tetracycline, chloramphenicol, erythromycin.',
        hindi: '- **बैक्टीरियोस्टेटिक** (विकास को रोकता है): टेट्रासाइक्लिन, क्लोरैम्फेनिकॉल, एरिथ्रोमाइसिन।',
            },
            {
              english: '  – **Narrow spectrum** (one type), **broad spectrum** (many types — chloramphenicol).',
        hindi: '- **संकीर्ण स्पेक्ट्रम** (एक प्रकार), **व्यापक स्पेक्ट्रम** (कई प्रकार - क्लोरैम्फेनिकॉल)।',
            },
            {
              english: '• **Antiseptics** — applied to **living tissue** (wounds, skin). Examples: dettol (chloroxylenol + terpineol), iodine (tincture = 2-3 % I₂ in alcohol-water), savlon, bithionol (in soaps), boric acid (eyewash).',
        hindi: '• **एंटीसेप्टिक्स** - **जीवित ऊतक** (घाव, त्वचा) पर लगाया जाता है। उदाहरण: डेटॉल (क्लोरोक्सीलेनॉल + टेरपीनॉल), आयोडीन (tincture = 2-3 % I₂ in alcohol-water), सेवलॉन, बिथियोनॉल (साबुन में), बोरिक एसिड (आईवॉश)।',
            },
            {
              english: '• **Disinfectants** — applied to **non-living** surfaces (floors, instruments). Examples: 1 % phenol, 0.2 % SO₂, chlorine in water (Cl₂ at 0.2-0.4 ppm).',
        hindi: '• **कीटाणुनाशक** - **निर्जीव** सतहों (फर्श, उपकरण) पर लगाया जाता है। उदाहरण: 1% फिनोल, 0.2% SO₂, पानी में क्लोरीन (Cl₂ 0.2-0.4 पीपीएम पर)।',
            },
            {
              english: '   ⇒ Same compound can be both depending on concentration: 0.2 % phenol antiseptic, 1 % disinfectant.',
        hindi: '⇒ सांद्रण के आधार पर एक ही यौगिक दोनों हो सकते हैं: 0.2% फिनोल एंटीसेप्टिक, 1% कीटाणुनाशक।',
            },
            {
              english: '**Antifertility drugs** — control population. Mixture of synthetic estrogens (e.g. ethynylestradiol/novestrol) and progesterone derivatives (norethindrone). Birth-control pill components.',
        hindi: '**प्रजननरोधी दवाएं**-जनसंख्या नियंत्रित करें। सिंथेटिक एस्ट्रोजेन का मिश्रण (जैसे ethynylestradiol/novestrol) और प्रोजेस्टेरोन डेरिवेटिव (नोरेथिंड्रोन)। जन्म-नियंत्रण गोली घटक.',
            },
          ],
        },
      ],
    },
    {
      id: 'food-chem',
      title: {
        english: 'Chemicals in Food',
        hindi: 'भोजन में रसायन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Artificial sweeteners** — non-caloric:',
        hindi: '**कृत्रिम मिठास** - गैर-कैलोरी:',
            },
            {
              english: '• Saccharin — 550× sweeter than sucrose; first synthetic; safe for diabetics.',
        hindi: '• सैकेरिन - सुक्रोज से 550× अधिक मीठा; पहला सिंथेटिक; मधुमेह रोगियों के लिए सुरक्षित.',
            },
            {
              english: '• Aspartame — 100×; unstable on heating (use cold drinks only).',
        hindi: '• एस्पार्टेम - 100×; गर्म करने पर अस्थिर (केवल ठंडे पेय का उपयोग करें)।',
            },
            {
              english: '• Sucralose — 600×; heat-stable.',
        hindi: '• सुक्रालोज़ - 600×; गर्मी बरकरार।',
            },
            {
              english: '• Alitame — 2000×; control of sweetness difficult.',
        hindi: '• अलीटेम - 2000×; मिठास पर नियंत्रण कठिन.',
            },
            {
              english: '**Preservatives** — prevent spoilage:',
        hindi: '**परिरक्षक** - ख़राब होने से बचाएँ:',
            },
            {
              english: '• Common salt — meat, pickles.',
        hindi: '• सामान्य नमक - मांस, अचार।',
            },
            {
              english: '• Sugar — jams, squashes.',
        hindi: '• चीनी - जैम, स्क्वैश।',
            },
            {
              english: '• Sodium benzoate ($C_6H_5COONa$) — limit ≤ 0.06–0.1 %.',
        hindi: '• सोडियम बेंजोएट ($C_6H_5COONa$) — सीमा ≤ 0.06–0.1 %।',
            },
            {
              english: '• Salts of sorbic / propionic acid.',
        hindi: '• सॉर्बिक/प्रोपियोनिक एसिड के लवण।',
            },
            {
              english: '**Antioxidants** — slow oxidation/rancidity. BHA (butylated hydroxyanisole), BHT, SO₂, sulphites.',
        hindi: '**एंटीऑक्सिडेंट** — धीमा ऑक्सीकरण/rancidity। बीएचए (ब्यूटाइलेटेड हाइड्रॉक्सीनिसोल), बीएचटी, एसओ₂, सल्फाइट्स। **खाद्य रंग, स्वाद, विटामिन** भी मिलाए गए। **साबुन** = लंबी श्रृंखला वाले फैटी एसिड (C₁₂–C₁₈) का सोडियम/पोटेशियम नमक। **सैपोनिफिकेशन** द्वारा तैयार: वसा + NaOH → साबुन + ग्लिसरॉल। ऑक्सीकरण/rancidity प्रक्रिया.',
            },
            {
              english: '**Edible colours, flavours, vitamins** also added.',
        hindi: '**खाद्य रंग, स्वाद, विटामिन** भी मिलाए गए।',
            },
          ],
        },
      ],
    },
    {
      id: 'soaps-detergents',
      title: {
        english: 'Soaps & Detergents',
        hindi: 'साबुन और अपमार्जक',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Soap** = sodium / potassium salt of long-chain fatty acid (C₁₂–C₁₈). Prepared by **saponification**: fat + NaOH → soap + glycerol. Hot/cold process.',
        hindi: '**साबुन** = लंबी श्रृंखला वाले फैटी एसिड का सोडियम/पोटेशियम नमक (C₁₂–C₁₈)। **सैपोनिफिकेशन** द्वारा तैयार: वसा + NaOH → साबुन + ग्लिसरॉल। Hot/cold प्रक्रिया.',
            },
            {
              english: 'Sodium soap = hard (toilet/laundry); potassium soap = soft (shaving cream).',
        hindi: 'सोडियम साबुन = कठोर (शौचालय/कपड़े धोने का); पोटेशियम साबुन = नरम (शेविंग क्रीम)।',
            },
            {
              english: 'Soap **does not lather in hard water** (Ca²⁺/Mg²⁺ form insoluble scum: $2C_{17}H_{35}COONa + Ca^{2+} \\to (C_{17}H_{35}COO)_2Ca \\downarrow + 2Na^+$).',
        hindi: 'साबुन **कठोर पानी में झाग नहीं बनाता** (Ca²⁺/Mg²⁺ अघुलनशील मैल बनाता है: $2C_{17}H_{35}COONa + Ca^{2+} \\to (C_{17}H_{35}COO)_2Ca \\downarrow + 2Na^+$)। **डिटर्जेंट** = सिंथेटिक; कठोर जल में प्रभावी. तीन वर्ग:',
            },
            {
              english: '**Detergents** = synthetic; effective in hard water. Three classes:',
        hindi: '**डिटर्जेंट** = सिंथेटिक; कठोर जल में प्रभावी. तीन वर्ग:',
            },
            {
              english: '• **Anionic** (negatively charged head): sodium lauryl sulphate ($CH_3(CH_2)_{11}OSO_3^-Na^+$); sodium dodecylbenzenesulphonate (most common — ABS).',
        hindi: '• **आयनिक** (नकारात्मक रूप से चार्ज किया गया सिर): सोडियम लॉरिल सल्फेट ($CH_3(CH_2)_{11}OSO_3^-Na^+$); सोडियम डोडेसिलबेंजेनसल्फोनेट (सबसे आम - एबीएस)।',
            },
            {
              english: '• **Cationic** — quaternary ammonium salts; germicidal; e.g. cetyltrimethylammonium bromide (CTAB).',
        hindi: '• **धनायनिक** — चतुर्धातुक अमोनियम लवण; कीटाणुनाशक; जैसे सेटिलट्रिमिथाइलमोनियम ब्रोमाइड (सीटीएबी)।',
            },
            {
              english: '• **Non-ionic** — polyethylene glycol esters; mild; in liquid dishwash detergents.',
        hindi: '• **गैर-आयनिक** - पॉलीथीन ग्लाइकोल एस्टर; हल्का; तरल डिशवॉश डिटर्जेंट में। **बायोडिग्रेडेबिलिटी** - स्ट्रेट-चेन एल्काइल डिटर्जेंट बायोडिग्रेडेबल; **शाखाओं वाली श्रृंखला** (चतुर्थक सी के साथ) गैर-बायोडिग्रेडेबल, प्रदूषण का कारण बनती है; रैखिक एल्काइल बेंजीन सल्फोनेट्स (एलएएस) द्वारा प्रतिस्थापित।',
            },
            {
              english: '**Biodegradability** — straight-chain alkyl detergents biodegradable; **branched chain** (with quaternary C) non-biodegradable, cause pollution; replaced by linear alkyl benzene sulphonates (LAS).',
        hindi: '**बायोडिग्रेडेबिलिटी** - स्ट्रेट-चेन एल्काइल डिटर्जेंट बायोडिग्रेडेबल; **शाखाओं वाली श्रृंखला** (चतुर्थक सी के साथ) गैर-बायोडिग्रेडेबल, प्रदूषण का कारण बनती है; रैखिक एल्काइल बेंजीन सल्फोनेट्स (एलएएस) द्वारा प्रतिस्थापित।',
            },
            {
              english: 'Cleansing action: soap/detergent forms **micelle**; hydrophobic tail dissolves grease, hydrophilic head stays in water; emulsion washed away.',
        hindi: 'सफाई क्रिया: soap/detergent रूप **मिसेल**; हाइड्रोफोबिक पूंछ ग्रीस को घोल देती है, हाइड्रोफिलिक सिर पानी में रहता है; इमल्शन बह गया.',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Fat} + 3NaOH \\to \\text{soap} + \\text{glycerol}',
      desc: {
        english: 'Saponification',
        hindi: 'साबुनीकरण',
      },
    },
    {
      latex: 'CH_3(CH_2)_{11}OSO_3^-Na^+',
      desc: {
        english: 'Sodium lauryl sulphate (anionic)',
        hindi: 'सोडियम लॉरिल सल्फेट (आयनिक)',
      },
    },
    {
      latex: 'C_6H_5COONa',
      desc: {
        english: 'Sodium benzoate (preservative)',
        hindi: 'सोडियम बेंजोएट (संरक्षक)',
      },
    },
    {
      latex: '\\text{Saccharin sweetness} \\approx 550\\times \\text{sucrose}',
      desc: {
        english: 'Sweetener',
        hindi: 'स्वीटनर',
      },
    },
    {
      latex: '2C_{17}H_{35}COONa + Ca^{2+} \\to (C_{17}H_{35}COO)_2Ca\\downarrow',
      desc: {
        english: 'Hard-water scum',
        hindi: 'कठोर जल का मैल',
      },
    },
    {
      latex: '\\text{Penicillin: } \\beta\\text{-lactam ring}',
      desc: {
        english: 'Targets cell-wall synthesis',
        hindi: 'कोशिका-दीवार संश्लेषण को लक्षित करता है',
      },
    },
    {
      latex: 'Cl_2 \\text{ in water at } 0.2\\text{–}0.4\\ \\text{ppm}',
      desc: {
        english: 'Water disinfection',
        hindi: 'जल कीटाणुशोधन',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'JEE Main',
      tag: 'Antiseptic',
      problem: {
        english: 'Iodoform when applied to wound is:',
        hindi: 'घाव पर लगाने पर आयोडोफॉर्म होता है:',
      },
      answer: {
        english: 'Antiseptic',
        hindi: 'एंटीसेप्टिक',
      },
      solution: {
        english: 'Releases I₂ on contact with tissue.',
        hindi: 'ऊतक के संपर्क में आने पर I₂ जारी करता है।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Drug',
      problem: {
        english: 'Aspirin acts as:',
        hindi: 'एस्पिरिन इस प्रकार कार्य करती है:',
      },
      answer: {
        english: 'Non-narcotic analgesic and antiplatelet',
        hindi: 'गैर-मादक दर्दनाशक और एंटीप्लेटलेट',
      },
      solution: {
        english: 'Acetylates COX, prevents prostaglandin synthesis.',
        hindi: 'एसिटिलेट्स COX, प्रोस्टाग्लैंडीन संश्लेषण को रोकता है।',
      },
    },
    {
      year: 2022,
      exam: 'JEE Main',
      tag: 'Sweetener',
      problem: {
        english: 'Artificial sweetener used by diabetics that is heat-stable:',
        hindi: 'मधुमेह रोगियों द्वारा उपयोग किया जाने वाला कृत्रिम स्वीटनर जो गर्मी-स्थिर है:',
      },
      answer: {
        english: 'Sucralose',
        hindi: 'सुक्रालोज़',
      },
      solution: {
        english: 'Aspartame breaks down on heating.',
        hindi: 'गर्म करने पर एस्पार्टेम टूट जाता है।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Detergent',
      problem: {
        english: 'Cetyltrimethylammonium bromide is:',
        hindi: 'सेटिलट्रिमिथाइलमोनियम ब्रोमाइड है:',
      },
      answer: {
        english: 'Cationic detergent',
        hindi: 'धनायनित डिटर्जेंट',
      },
      solution: {
        english: 'Quaternary ammonium salt.',
        hindi: 'चतुर्धातुक अमोनियम नमक।',
      },
    },
    {
      year: 2020,
      exam: 'JEE Main',
      tag: 'Antibiotic',
      problem: {
        english: 'Bactericidal antibiotic among:',
        hindi: 'इनमें से जीवाणुनाशक एंटीबायोटिक:',
      },
      answer: {
        english: 'Penicillin (vs tetracycline = bacteriostatic)',
        hindi: 'पेनिसिलिन (बनाम टेट्रासाइक्लिन = बैक्टीरियोस्टेटिक)',
      },
      solution: {
        english: 'Penicillin kills bacteria.',
        hindi: 'पेनिसिलिन बैक्टीरिया को मारता है। **वर्नर (1898)** — केंद्रीय धातु दो संयोजकता प्रदर्शित करती है:',
      },
    },
  ],
  next: {
    slug: 'general-organic-chemistry',
    title: 'General Organic Chemistry',
  },
};

export default chapter;
